import type { TransportAction } from '@/models/transport/transport-action';
import type { Assignment } from '@/models/assignment/assignment';

export interface TransportRoutingModel {
    isOptimizing: boolean;
    isOptimized: boolean;
    hasRoute: boolean;
    calculatingRoute: boolean;
    actions: TransportAction[];
    totalDuration: number | null;
    totalDistance: number | null;
    totalCost: number | null;
    totalRevenue: number | null;
    polyLine?: string | null;
    conflictingVehicles: Assignment[];
}

export const DefaultTransportRoutingModel = (): TransportRoutingModel => {
    return {
        isOptimizing: false,
        isOptimized: false,
        hasRoute: false,
        calculatingRoute: false,
        actions: [],
        totalDuration: null,
        totalDistance: null,
        totalCost: null,
        totalRevenue: null,
        polyLine: null,
        conflictingVehicles: []
    };
}

